export default __webpack_public_path__ + "static/media/logo2.d6e95473.png";